module.exports = __webpack_public_path__ + "static/media/boy.41072557.png";